import React from 'react'
import '../container.css'
var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();

today = mm + '/' + dd + '/' + yyyy;
const Hakkinda = () => {
    return (
        <div className="info-pages-container">
            <h2 id="head">Site Hakkında</h2>
            <br></br>
            <p>Bu site etrafınızda gördüğünüz bitki türlerinin isimlerini bulmanızı, onları tanımanızı ve onlarla ilgili
araştırma yapmanıza yardımcı olacak bir kaynak sağlamayı amaçlamaktadır. Sitemiz Doğa Koruma
Merkezi’nin desteği, gönüllülerin emekleri ve ODTÜ BÖTE Bölümünün katkılarıyla hazırlanmıştır.
Sitede yer alan fotoğraflar indirilebilir ve <span className="tooltip"><span className="tooltiptext">Zeydanlı, U. 2020. ODTÜ Florası ve Kır Çiçekleri Rehberi. Doğa Koruma Merkezi. Erişim tarihi {today}. {"<http://165.232.80.248:6001>"}</span>referans</span> göstererek kullanılabilir.</p>
            <br></br>
            <p>Doğada dolaşmayı seven insanlar bir süre sonra ister istemez etrafında gördükleri canlılara merak duymaya başlar. Bunların başında da bitkiler, kuşlar ve kelebekler gelir. Hepsi göz alıcı, dikkat çekici canlılardır. Böcekler, mantarlar, örümcekler gibi canlı grupları ile de ilgileneler çıkar ama genelde bu insanların sayıları daha azdır.
            Doğaseverler, farkında olmadan bu canlıların birçok farklı özelliklerini gözlemlemeye, izlemeye başlar. Bir sonraki aşamada da bu canlıların isimleri merak edilmeye başlanır. Beyaz çiçek, küçük kuş gibi tanımlamalar yerini çoban çantası, ispinoz gibi isimlere bırakır.</p>
            <br></br>
            <p>ODTÜ arazisinde, ODTÜ’lü olsun veya olmasın yüzlerce doğasever dolaşmakta. Doğada dolaşmayı
seven insanlar bir süre sonra ister istemez etrafında gördükleri canlılara merak duymaya başlar.
Bunların başında da bitkiler, kuşlar ve kelebekler gelir. Sayıları daha az olmakla birlikte, böcekler,
mantarlar, örümcekler gibi canlı grupları ile de ilgileneler de vardır. Bu canlıların hepsi göz alıcı ve
dikkat çekicidir. Doğaseverler, farkında olmadan bu canlıların birçok farklı özelliklerini gözlemlemeye,
izlemeye başlar. Bir sonraki aşamada da bu canlıların isimleri merak edilmeye başlanır. Beyaz çiçek,
küçük kuş gibi tanımlamalar yerini çobançantası, ispinoz gibi isimlere bırakır.</p>
            <br></br>
            <p>Bu site ile biz de etrafınızda gördüğünüz bitki türlerini tanımanıza, ismini bulmanıza,
onlarla ilgili daha fazla araştırma yapmanıza yardımcı olacak bir kaynak hazırlamaya
çalıştık.</p>
            <br></br>
            <h2 style={{ textAlign: "center" }}>Bu siteyi kullanarak gördüğünüz bitkileri tanımlayıp, isimlerini öğrenebilirsiniz.</h2>
            <br></br>
            <p>Bitkileri tanımlamada kullanılacak en ayırt edici özelliklerden biri çiçekleridir. Çiçek rengi ve şekli
tanımlamada kullanılabileceğiniz ilk adımdır. Ondan sonra da bitkinin boyutu, yaprak şekli, tüyleri,
meyvesi gibi birçok özelliğinden faydalanabilirsiniz. Bu site, bitki tanımlamada bu adımları
kullanabileceğiniz bir araç olarak hazırlanmıştır.</p>
            <br></br>
            <p>Bitkileri fotoğraflardan tanımlayan birçok akıllı telefon uygulaması var; Fotoğrafını çekiyorsunuz ve
uygulama sizi türünü söylüyor. Ancak:</p>
            <ol>
                <br></br>
                <li>Türkiye gibi çok zengin bitki varlığına sahip ülkelerde (yaklaşık 10.000 bitki türümüz var ve bunların
yaklaşık 3500 tanesi Türkiye’ye özgü) türlerin önemli kısmı çok benzerdir ve birbirinden ancak çok
ufak ayrıntılarla ayrılabilirler, bu yüzden tanımlama programlarının bu bitkileri ayırt etmesi çok
zordur.</li>
                <br></br>
                <li>Bu programların sağlıklı çalışabilmesi için arka planda türün farklı özelliklerini yanıştan çok sayıda
fotoğrafın bulunması gerekmektedir.</li>
                <br></br>
                <li>Bizler, insanın merak ettiği bir türü kendisinin bulmasının daha eğlenceli ve öğretici olduğuna
inanıyoruz. Bu süreçte daha fazla gözlem yapıp, bitkiler ve doğa hakkında yeni bilgiler öğreniyor
olacağınızı umuyoruz.</li>
            </ol>
            <br></br>
            <p>Bu site ile böyle bir araç hazırlamayı amaçladık.</p>
            <div style={{ marginTop: 15 }}>
                <a href="#head"><i class="fas fa-arrow-up" style={{ fontSize: 30 }}></i></a>
            </div>
        </div>
    )
}

export default Hakkinda